import packagesReducer from './packagesReducer';
import termsReducer from './termsReducer';

export default {
  packages: packagesReducer,
  terms: termsReducer,
};
